export const HOUR = 60;
export const RESOLUTION = 15;
export const WORKING_HOURS = [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
export const DEFAULT_ERROR = 'Сталася помилка, зміни не збережені.';
export const NOTIFICATIONS_SUBSCRIPTION_ERROR =
  'Не вдалося оновити підписку на push-повідомлення. Перевірте налаштування push-повідомлень а налаштуваннях телефона.';
